function injectStyle (ssrContext) {
  require("!!../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-2450ac32\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?{\"includePaths\":[\"/Users/noomz/Projects/Opendream/kadnud/kadnud-eef-app/src/css\"],\"sourceMap\":true}!../../../vue-loader/lib/selector?type=styles&index=0!./Facebook.vue")
}
var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./Facebook.vue"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-2450ac32\",\"hasScoped\":true}!../../../vue-loader/lib/selector?type=template&index=0!./Facebook.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2450ac32",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-goodshare/src/providers/Facebook.vue
// module id = 691
// module chunks = 1